import { FC, useEffect } from 'react';
import { useField } from 'react-final-form';
import Spacing from 'components/Spacing';
import { Body, BodySmall } from 'components/Typography';
import { TextFieldWithFloatingLabel } from 'components/FinalForm/TextFieldWithFloatingLabel';
import theme from 'config/theme';
import { DetailsColumn, DetailsRow, NameValidationError } from 'screens/Checkout/styled';
import {
  individualOnlyWarningFull,
  individualOnlyWarningShort,
  required,
  validateNameCheckout,
} from 'helpers/validation';

interface Props {
  isLoggedIn: boolean;
}

export const PersonalDetails: FC<Props> = ({ isLoggedIn }) => {
  const {
    meta: { error: firstNameError },
  } = useField('first_name', { subscription: { error: true } });
  const {
    meta: { error: lastNameError },
  } = useField('last_name', { subscription: { error: true } });

  useEffect(() => {
    // TODO: log firebase event view DAF personal details
  }, []);

  return (
    <>
      <Body>Personal Details</Body>
      {(firstNameError === individualOnlyWarningShort ||
        lastNameError === individualOnlyWarningShort) && (
        <NameValidationError>
          <BodySmall $color={theme.colors.errorRed}>{individualOnlyWarningFull}</BodySmall>
        </NameValidationError>
      )}
      <DetailsColumn>
        <DetailsRow>
          <TextFieldWithFloatingLabel
            name="email"
            label="Email"
            validate={required}
            disabled={isLoggedIn}
          />
        </DetailsRow>
        <DetailsRow>
          <TextFieldWithFloatingLabel
            label="First Name"
            name="first_name"
            validate={validateNameCheckout}
          />
          <TextFieldWithFloatingLabel
            name="last_name"
            label="Last Name"
            validate={validateNameCheckout}
          />
        </DetailsRow>
      </DetailsColumn>
      <Spacing $size={12} />
    </>
  );
};
